// Endpoints pour les nouvelles types de selects 
export const TemplatesEnpoints = {
  postCategories: "addCategories",
  postTypeTemplate: "templates",
  postTypeCode: "addTypesCode",
  postTemplateWorker: "templates",
  postTypeTelechagerTemplate: "type-telechargement",
  getTypeTemplate: "types-templates",
  getCategory: "categories",
  getTypesCode: "types-codes",
  getCategorieTemplate: "categories-templates",
};

export const AuthentificationEndpoints = {
  updatePassword: "reinitialiser",
  addResetLinkEmail: "demande",
  resetPassword: "resetPassword",
  getAccessToken: "getAccessToken",
  refreshToken: "refresh",
  getUserData: "getUserData",
  addGoogleUser: "addGoogleUser",
  register: "register",
  login: "login",
  logout: "logout",
  postUserLogin: "login",
  updateUserData: "modifier-infos/",
};

export const idpEndpoints = {
  post_data: "/",
  get_data: "/",
  getAccessToken: "/",
  getRefreshToken: "/",
  
}

export const ProjectsEndpoints = {
  postPorteurProjet: "porteur-projet/",
  postProjet: "projets",
  getProjects: "projets",
  getOneProjects: "getProjects?id=",
  getTemplates: "templates/{type?}",
  postForStore: "store",
  updateTask: "modifier-tache/",
  getTasks: "taches",
  getTaskById: "taches/",
  getTaskByProjectId:"projet-taches/",
  postCandidature: "postuler/",
  getPostulant: "postulants/",
  postCandidatureJoin: "rejoindre/",
  updateAssignation: "assigner/",
  updateParticipants: "participer/",
  getProjectMembers: "rejoignants/",
  getParticipants: "participants/",
  postCommentTask: "commentaires-tache/",
  getComments: "commentaires-tache/",
  deleteMicroTask: "commentaires/",
  updateComment: "commentaires/",
  postLivraisonComment: "commentaires-livraison/",
  getCommentsLivraisons: "commentaires-livraison/",
  postMicroTask: "micro-taches/",
  getMicroTask: "micro-taches/",
  updateMicroTask: "terminer/",
  ajoutLivraison: "livraisons/",
  ajoutLivraisonCoach: "livraisons-coach/",
  getLivraisons: "livraisons/",
  getLivraisonsCoach: "livraisons-coach/",
  deleteDelivary: "livraisons/",
  getLivraisonById: "livraison/",
  getFinaleLivraisonTask: "livraisons-finales/",
  validerLivraison: "valider-livraison/",
  approuverLivraisonFinal: "approuver-livraison/",
  partagerLivraisonFinale: "partager-livraison/",
  validerLivraisonCoach: "valider-livraisons-coach/",
  rejeterLivraison: "rejeter-livraison/",
  rejeterLivraisonCoach: "rejeter-livraisons-coach/",
  updateDelivery: "modifier/",
  updateCoachDelivery: "modifier-livraisons-coach/",
  validerTache: "valider-tache/",
  rejeterTache: "rejeter-tache/",
  updateTaskDate: "dates/",
  getNotifications: "notifications",
  putNotifications: "notifications/",
  deleteNotifications: "notifications/",
  categoriesProjets: "categories-projets/",
  services: "services/",
  //endpoints KPIS
  nombreProjetCoach: "nombre-projets-coach/",
  nombreProjetParticipant: "nombre-projets-participant/",
  nombreLivrableCoach: "nombre-livrables-coach/",
  nombreLivrableBakeliste: "nombre-livrables-bakeliste/",
  statsHebdomadaires: "stats-taches/",
  statsHebdomadairesBakeliste: "stats-taches-participant/"
};